import React from 'react';
import styled from 'react-emotion';

const Description = styled('article')`
  line-height: 1.6;

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }
`;

export const SectionHeading = styled('h2')`
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.3rem;
`;

const ProductInfo = ({ product }) => {
  return (
    <Description
      dangerouslySetInnerHTML={{
        __html: product.description
      }}
    />
  );
};

export default ProductInfo;
